import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import AdminDashboard from './Dashboard';
import CMS from './CMS';
import PageManager from './PageManager';
import NoticeManager from './NoticeManager';
import MediaManager from './MediaManager';
import VideoManager from './VideoManager';
import ImageGalleryManager from './ImageGalleryManager';
import BuildingManager from './BuildingManager';
import OwnerManager from './OwnerManager';
import OwnerAssignment from './OwnerAssignment';
import UserManager from './UserManager';
import ArtisanCommands from './ArtisanCommands';

const AdminRouter: React.FC = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="/cms" element={<CMS />} />
        <Route path="/pages" element={<PageManager />} />
        <Route path="/notices" element={<NoticeManager />} />
        <Route path="/videos" element={<VideoManager />} />
        <Route path="/image-galleries" element={<ImageGalleryManager />} />
        <Route path="/buildings" element={<BuildingManager />} />
        <Route path="/owners" element={<OwnerManager />} />
        <Route path="/owner-assignment" element={<OwnerAssignment />} />
        <Route path="/users" element={<UserManager />} />
        <Route path="/media" element={<MediaManager />} />
        <Route path="/media/upload" element={<MediaManager />} />
        <Route path="/artisan" element={<ArtisanCommands />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRouter;
